/**
 * @module  Experience/hardgoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * Constants for hardgoods
 */
export const HARDGOODS_MODULE_COMPONENTS = {
  HARDGOODS_MODULE_NAME: 'Hardgoods Module',
  BROWSE_HARDGOODS_SERVICE: 'BrowseHardgoodsService',
  BROWSE_DEVICE_LANDING_COMPONENT: 'BrowseDeviceLandingComponent',
  BROWSE_HARDGOOD_COMPONENT: 'BrowseHardgoodComponent',
  HARDGOOD_PRICE_COMPONENT: 'HardgoodPriceComponent',
  HARDGOODS_FILTER_SORT_COMPONENT: 'HardgoodsFilterSortComponent',
  COMPARE_HARDGOODS_SERVICE: 'CompareHardgoodsService',
  COMPARE_DEVICE_COMPONENT: 'CompareDevicesComponent',
  UNASSISTED: 'Unassisted',
  SELF_SERVICE_ANONYMOUS: 'Self Service Anonymous',
  GENERAL_ANONYMOUS: 'General Anonymous',
  ACTIVATION: 'ACTIVATION',
  OFFER_ID: 'offerId',
  LEGAL_TEXT: 'legal-text',
  CONTAINER_HOLDER: 'container-holder',
  COLUMN_CONTROL: 'columnControl',
  BRING_YOUR_OWN_DEVICE_FAQ: 'bring-your-own-device/faq',
  COLUMN_CONTROL_BYOD: 'columnControlWebImg',
};
